import type { TextPropsTextConfig } from '@features/powerpoint';
import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';

// unicode character ↳ used as substitute for indent which cannot be done easily in pptxgenjs
const INDENT_CHARACTER = '\u21B3';

export const definitionTextV2 = (
  label: string,
  definition: string,
  options?: { subItem?: boolean }
): TextPropsTextConfig[] => {
  const { subItem } = options ?? { subItem: false };

  return [
    {
      text: subItem ? `${INDENT_CHARACTER} ${label}` : label,
      options: {
        color: subItem ? themeV2.colors.black : themeV2.colors.inmarketGreen,
        fontFace: DEFAULT_FONT,
        bold: !subItem,
        breakLine: true,
        paraSpaceAfter: 0,
        paraSpaceBefore: 0,
      },
    },
    {
      text: definition,
      options: {
        fontFace: DEFAULT_FONT,
        breakLine: true,
        paraSpaceAfter: 2,
        paraSpaceBefore: 0,
      },
    },
  ];
};
